import React, { useEffect } from "react";
import { useParams, useNavigate, useLocation, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGS, DEFAULT_LANG, swapLang } from "../../utils/langUtils";

const LanguageLayout = () => {
    const { lang } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { i18n } = useTranslation();

    useEffect(() => {
        // 1. Validate Language
        if (!SUPPORTED_LANGS.includes(lang)) {
            // If invalid lang (e.g. /xx/about), swap to default (e.g. /en/about)
            const newPath = swapLang(location.pathname, DEFAULT_LANG);
            navigate(`${newPath}${location.search}${location.hash}`, { replace: true });
            return;
        }

        // 2. Sync i18n (Single Source of Truth is URL)
        if (i18n.language !== lang) {
            i18n.changeLanguage(lang);
        }

        // 3. Direction handling is global in useDirection hook, 
        // which watches i18n.language, so it will update automatically.

    }, [lang, i18n, navigate, location]);

    if (!SUPPORTED_LANGS.includes(lang)) {
        return null; // Render nothing while redirecting
    }

    return <Outlet />;
};

export default LanguageLayout;
